<template>
  <div>
    <my-header
      :page_name="$t('navigation.headerTitles.services')"
      show_usermenu
    ></my-header>

    <div class="settings-line">
      <div class="settings-element">
        <label>{{ $t('services.server') }}</label>
        <el-select
          v-model="serverSelected"
          @change="serverChanged"
          filterable
        >
          <el-option
            v-for="(server, index) in getServersArray"
            :key="index"
            :value="server.id"
            :label="server.name"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div
      class="buttons-grid"
      v-if="!!serverSelected"
    >
      <!-- <el-button class="el-icon-">Скачать</el-button> -->
      <div class="icon-buttons">
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('services.start')"
          placement="bottom-start"
        >
          <span>
            <el-button
              @click="createAndSendIdArray('inactive', 'start')"
              :disabled="startDisabled"
              type="primary"
              class="el-icon-caret-right"
            ></el-button>
          </span>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('services.restart')"
          placement="bottom-start"
        >
          <span>
            <el-button
              @click="createAndSendIdArray('active', 'restart')"
              type="primary"
              :disabled="restartDisabled"
              class="el-icon-refresh-right"
            ></el-button>
          </span>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('services.stop')"
          placement="bottom-start"
        >
          <span>
            <el-button
              @click="createAndSendIdArray('active', 'stop')"
              class="el-icon-switch-button"
              type="danger"
              :disabled="stopDisabled"
            ></el-button>
          </span>
        </el-tooltip>
      </div>
    </div>
    <!-- чтобы не было пустой полосы при невыбранном сервере -->
    <div
      v-else
      class="buttons-grid"
      style="padding-top: 5.2px"
    ></div>

    <el-row
      type="flex"
      justify="space-between"
    >
      <el-col
        :span="24"
        class="grid-container-smaller"
      >
        <ag-grid-vue
          v-if="!!serverSelected"
          style="width: 100%; height:100%; font-family: 'Open Sans', sans-serif;"
          class="ag-theme-balham"
          :columnDefs="columnDefs"
          :localeText="agGridlocaleText"
          :rowData="getServices"
          :defaultColDef="defaultColDef"
          :gridOptions="gridOptions"
          rowSelection="multiple"
          rowDeselection
          suppressCellSelection
          @grid-ready="onGridReady"
          @first-data-rendered="onGridFirstDataRendered"
          @gridSizeChanged="onGridSizeChanged"
          @rowSelected="onRowSelected"
          @row-data-changed="onGridDataChanged"
        ></ag-grid-vue>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Header from "../../components/reusable/header/Header";
import { mapGetters } from "vuex";
import { AgGridVue } from "ag-grid-vue";
import agGridLocaleRu from "@/locales/ru/agGrid";
import agGridLocaleUa from "@/locales/ua/agGrid";
import agGridLocaleEn from "@/locales/en/agGrid";
import i18n from "@/locales";
export default {
  data() {
    return {
      gridData: null,
      columnDefs: null,
      defaultColDef: null,
      gridApi: null,
      gridOptions: null,
      agGridlocaleText: null,
      columnApi: null,
      settings: null,
      currentRowSelected: null,
      startDisabled: true,
      restartDisabled: true,
      stopDisabled: true,
      serverSelected: null,
      firstRenderFlag: false,
    };
  },
  methods: {
    createAndSendIdArray(status, method) {
      let actionName = "";
      if (method === "start") actionName = this.$t('services.willStart');
      else if (method === "restart") actionName = this.$t('services.willRestart');
      else actionName = this.$t('services.willStop');

      let selectedArray = this.gridApi.getSelectedRows();
      const isEqual = (arr) => arr.every((v) => v.pst === status);
      if (isEqual(selectedArray) && selectedArray.length > 1) {
        this.$confirm(
          `${this.$t('services.thisAction')} ${actionName} ${this.$t('services.thisServicesContinue')}`,
          this.$t('services.attention'),
          {
            confirmButtonText: "OK",
            cancelButtonText: this.$t('services.attention'),
            type: "warning",
          }
        )
          .then(() => {
            this.$store.commit("setLoading", true);
            let servicesIds = [];
            // selectedArray.forEach(service => {serviceIds.push(service.c)});
            for (let service of selectedArray) {
              //console.log(service);
              servicesIds.push(service.c);
            }
            return this.$store.dispatch("actionWithService", {
              idServer: this.serverSelected,
              method,
              services: servicesIds,
            });
          })
          .then(() => {
            return this.$store.dispatch("getServices", this.serverSelected);
          })
          .then(() => {
            this.$message(`${this.$t('services.operation')} "${actionName}${this.$t('services.softSign')}" ${this.$t('services.operation')}`);
            this.$store.commit("setLoading", false);
          })
          .catch(() => {
            this.$message(
              `${this.$t('services.whenOperationPerforming')} "${actionName}" ${this.$t('services.errorOccured')}`
            );
            this.$store.commit("setLoading", false);
          });
      } else if (!isEqual(selectedArray) && selectedArray.length > 1) {
        this.$store.commit(
          "setError",
          this.$t('services.diffStatusesOfServicesError')
        );
      } else {
        //если одна строка выделена
        this.$confirm(
          `${this.$t('services.thisAction')} ${actionName} ${this.$t('services.thisServiceContinue')}`,
          this.$t('services.attention'),
          {
            confirmButtonText: "OK",
            cancelButtonText: this.$t('services.cancel'),
            type: "warning",
          }
        )
          .then(() => {
            this.$store.commit("setLoading", true);
            return this.$store.dispatch("actionWithService", {
              idServer: this.serverSelected,
              method,
              services: [selectedArray[0].c],
            });
          })
          .then(() => {
            //console.log("DONE");
            return this.$store.dispatch("getServices", this.serverSelected);
          })
          .then(() => {
            this.$message(`${this.$t('services.operation')} "${actionName}${this.$t('services.softSign')}" ${this.$t('services.completeSuccess')}`);
            this.$store.commit("setLoading", false);
          })
          .catch(() => {
            this.$message(
              `${this.$t('services.whenOperationPerforming')} "${actionName}${this.$t('services.softSign')}" ${this.$t('services.errorOccured')}`
            );
            this.$store.commit("setLoading", false);
          });
      }
    },
    serverChanged() {
      this.$localStorage.set(
        "wa-services",
        JSON.stringify(this.serverSelected)
      );
      this.$store
        .dispatch("getServices", this.serverSelected)
        .then(() => {
          if (this.getServices.length === 0) {
            this.$store.commit("setLoading", false);
          }
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.gridApi.setEnableCellTextSelection(true);
    },
    onGridDataChanged() {
      if (this.firstRenderFlag) this.$store.commit("setLoading", false);
    },
    onGridSizeChanged(params) {
      params.api.sizeColumnsToFit();
    },
    onGridFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
      this.settings.grids.packs.viewFull = false;
      this.$store.commit("setLoading", false);
      this.firstRenderFlag = true;
    },
    onRowSelected(params) {
      //console.log(params);
      if (params.node.selected) {
        this.currentRowSelected = params.node.data; // текущая выбранная строка грида запоминается в буфере
        this.database = this.currentRowSelected.db;
        //console.log("CURRENT ROW: ", this.currentRowSelected);
        if (this.currentRowSelected.pst === "active") {
          this.startDisabled = true;
          this.restartDisabled = false;
          this.stopDisabled = false;
        } else if (this.currentRowSelected.pst === "inactive") {
          this.startDisabled = false;
          this.restartDisabled = false;
          this.stopDisabled = true;
        } else {
          //failed
          this.startDisabled = true;
          this.restartDisabled = true;
          this.stopDisabled = true;
        }
      }
    },
  },
  beforeMount() {
    const locale = i18n.locale;
    switch (locale) {
      case "ru":
        this.agGridlocaleText = agGridLocaleRu;
        break;
      case "ua":
        this.agGridlocaleText = agGridLocaleUa;
        break;
      case "en":
        this.agGridlocaleText = agGridLocaleEn;
        break;
      default:
        this.agGridlocaleText = agGridLocaleRu;
    }
    this.gridOptions = {
      rowClassRules: {
        "active-status": (params) => params.data.pst === "active",
        "failed-status": (params) => params.data.pst === "failed",
        "inactive-status": (params) => params.data.pst == "inactive",
      },
    };
    this.columnDefs = [
      { headerName: i18n.t("tableHeaders.service.s"), field: "s" },
      {
        headerName: i18n.t("tableHeaders.service.p"),
        field: "p",
        valueGetter: (params) =>
          params.data.p === "null" ? null : params.data.p,
      },
      { headerName: i18n.t("tableHeaders.service.st"), field: "st" },
      { headerName: i18n.t("tableHeaders.service.dst"), field: "dst" },
    ];
    this.defaultColDef = {
      resizable: true,
      sortable: true,
      filter: true,
      autoHeight: true,
    };
    this.settings = {
      grids: {
        packs: {
          viewFull: false,
        },
      },
    };
  },
  created() {
    this.$store.commit("setLoading", true);
    this.$store.dispatch("getServers").then(() => {
      let serv = JSON.parse(this.$localStorage.get("wa-services"));
      if (serv) {
        if (!this.getServersArray.find((s) => s.id === serv)) {
          this.$store.commit("setLoading", false);
          return;
        }
        this.serverSelected = serv;
        this.serverChanged();
      } else this.$store.commit("setLoading", false);
    });
  },
  computed: {
    ...mapGetters(["getServices", "getServersArray"]),
  },
  components: {
    myHeader: Header,
    AgGridVue,
  },
};
</script>

<style scoped>
.el-select {
  width: 100%;
}
</style>